var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',_vm._l((_vm.languages),function(entry){return _c('a',{key:entry.title,staticClass:"flag-language mr-1",on:{"click":function($event){return _vm.changeLocale(entry.language)}}},[_c('img',{attrs:{"src":entry.icon,"alt":""}})])}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }